import useAuth from 'hooks/use-auth'
import { useGremlinPagination } from 'hooks/use-gremlin-query'
import {
  DEFAULT_NOW_RUNNING_QUERY_PAGE_SIZE,
  type PaginatedQueryOptions
} from 'queries/queries-utils'
import { scenariosQueryKeys } from 'queries/scenarios/query-keys'

import type { ScenariosActivePagedResponse } from 'types/api/scenarios/active'

export function useGetScenariosActiveWithPagination({
  pageSize = DEFAULT_NOW_RUNNING_QUERY_PAGE_SIZE,
  ...queryOptions
}: PaginatedQueryOptions<ScenariosActivePagedResponse> = {}) {
  const { currentTeamId } = useAuth()

  return useGremlinPagination<ScenariosActivePagedResponse>(
    `scenarios/active/paged?pageSize=${pageSize}`,
    {},
    {
      ...queryOptions,
      queryKey: scenariosQueryKeys.getScenariosActivePaged({
        teamId: currentTeamId,
        pageSize
      })
    }
  )
}
